/**
 * @copyright       Palace Resorts
 * @description     Mensajes para el layout de usuarios de la aplicación (Members Layout)
 * @author          Roberto Pérez Guzmán
 * @creationDate    03 de Mayo del 2020
 */
export default {
    fallbackLocale: 'ESP',
    locale: 'ESP',
    messages: {
        'ESP': {
            
        },
        'ENG': {
            
        }
    } //end Messages
}